import React from 'react';
import { CircleCheckIcon, CircleXIcon } from 'lucide-react';
import { afterItems, beforeItems } from '../../data/landing';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
export function BeforeAfter() {
  return <section className="w-full bg-canvas px-5 py-16 md:py-24" data-id="element-95" data-mp="26k04imtveq2k">
      <div className="mx-auto max-w-5xl" data-id="element-96" data-mp="22m2czdcmnrw0">
        <SectionHeading title="What changes when you map the case first" data-id="element-97" data-mp="2zb1or2cf7bsy" />

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-98" data-mp="2za8nui057giq">
          <div className="rounded-3xl bg-white p-6 ring-1 ring-alert/20 md:p-8" data-id="element-99" data-mp="2ubp0cd5whwo9">
            <div className="flex items-center gap-3" data-id="element-100" data-mp="2q9u3bkv065ga">
              <span className="rounded-full bg-alert px-4 py-1.5 text-sm font-extrabold uppercase tracking-wider text-white" data-id="element-101" data-mp="2q8iqkvjkxnd1">Before</span>
              <span className="text-sm font-semibold text-muted" data-id="element-102" data-mp="1eux2zetdbttm">Planning from memory</span>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-103" data-mp="19vke6oixscoe">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3 text-[17px] leading-snug text-navy" data-id="element-104" data-mp="175m4x5jnfieq">
                  <CircleXIcon className="mt-0.5 h-6 w-6 shrink-0 text-alert" aria-hidden="true" data-id="element-105" data-mp="1c4z0qfshzztg" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl bg-navy p-6 md:p-8" data-id="element-106" data-mp="133ir4a9ic1qa">
            <div className="flex items-center gap-3" data-id="element-107" data-mp="131xwkkn70isf">
              <span className="rounded-full bg-cta px-4 py-1.5 text-sm font-extrabold uppercase tracking-wider text-white" data-id="element-108" data-mp="oemjuff9ysqq">After</span>
              <span className="text-sm font-semibold text-sky-light" data-id="element-109" data-mp="t75w99287hty">With Ortho Treatment Map™</span>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-110" data-mp="fc3la7iiv2aa">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3 text-[17px] font-medium leading-snug text-white" data-id="element-111" data-mp="jg1i2bkdk106">
                  <CircleCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-[#4ADE80]" aria-hidden="true" data-id="element-112" data-mp="5icxz5y4sxw6" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-12" data-id="element-113" data-mp="27dkij6oic2jr">
          <CtaButton label="I want a structured treatment map" data-id="element-114" data-mp="27chs0zv3k24d" />
        </div>
      </div>
    </section>;
}